import React, { useState, useEffect } from 'react';
import logoLogin from '../../img/logo_final_png.png';
import Swal from 'sweetalert2'
import ViewLogin from '../../containers/ViewLogin/ViewLogin';
import { Translate } from '../../language';
import { connect } from 'react-redux'
import { loginEmail, loginEmailPassword, loginEmailPasswordAdmin } from '../../actions/loginActions'


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const LoginAdmin = ({ history, loginEmail, loginEmailPasswordAdmin, errorType, isLoading }) => {
    const [user, setUser] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)
    console.log()
    useEffect(() => {
        var user = 'user'
        if (errorType !== null && errorType.code === "ERR002") {
            setError(prevError => ({
                ...prevError,
                [user]: Translate('ERR002', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR095") {
            Toast.fire({
                icon: 'error',
                title: 'Ya existe un usuario con ese correo'
            })
            setError(prevError => ({
                ...prevError,
                [user]: Translate('ERR095', 'es')
            }));
        }

        if (errorType !== null && errorType.code === "ERR011") {
            setError(prevError => ({
                ...prevError,
                [user]: Translate('ERR011', 'es')
            }));
        }

        if (errorType !== null && errorType.code === "ERR044") {
            setError(prevError => ({
                ...prevError,
                [user]: Translate('ERR044', 'es')
            }));
        }



    }, [errorType])


    const goToLoginCode = (e) => {
        e.preventDefault()
        loginEmailPasswordAdmin(user, password, history)
    }

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }



    const isEmpty = (e) => {
        console.log()
        const { name, placeholder, value, type } = e.target;
        if (name ==='user') {
            setUser(value)
        } else {
            setPassword(value)
        }
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es')
            }));
        }
        else {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
            if (type === "email") {
                if ((value.includes("@") && value.includes(".")) === false) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('invalidEmail', 'es')
                    }));
                }

            }
            if (type === "password") {
                if (value.length < 6) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('passwordToShort', 'es')
                    }));
                }

            }
        }


    }


    return (
        <ViewLogin
        isAdmin
            islogin={true}
            type='email'
            nameInput='user'
            nameInputPassword='password'
            img={logoLogin}
            textWelcome=''
            inputValue={user}
            inputValuePassword={password}
            error={error.user}
            errorPassword={error.password}
            onChangeInput={isEmpty}
            onFocusInput={isFocused}
            inputPlaceholder="loginUser"
            inputPlaceholderPassword="loginPassword"
            textButton="login"
            actionButton={goToLoginCode}
            textDown='askForAccountLogin'
            TextlinkDown='creatYourAccount'
            linkToDown={{
                pathname: "/RegisterUser"
            }}
            isMenuDown={true}
            isBackgroundBlue={true}
            isActiveButton={isValidate}
            history={history}
            isLoginPassword={true}
            isLoading={isLoading}
        />
    )
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        errorType: state.register.errorType, // y lo que retorna map, connect lo envia a Page como Props 
        isLoading: state.register.isLoadingViewLoginPassword
    }
}


export default connect(mapStateToProps, { loginEmail, loginEmailPasswordAdmin })(LoginAdmin)

